import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { AlertsService } from '../../services/alerts.service';
import { BrowseService } from '../../browse/services/browse.service';
import cloneDeep from 'lodash/cloneDeep';

/**
 * Component for managing a user's library preferences.
 */
@Component({
	selector: 'user-libraries',
	templateUrl: './libraries.component.html',
	styleUrl: './libraries.component.css'
})
export class LibrariesComponent implements OnInit {

	LOCALIZATION: any;

	libraryPrefs: any[] = [];
	all_libraries: boolean = false;

	constructor(
		private alertsService: AlertsService,
		private browseService: BrowseService,
		private userService: UserService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.loadLibraries();
		this.checkAllLibraries();
	}

	private loadLibraries(): void {
		this.libraryPrefs = cloneDeep(this.userService.user.properties.awlibraryObjectList);
	}

	checkAllLibraries(): void {
		if (this.libraryPrefs && this.libraryPrefs.length > 0) {
			let all = true;
			for (let i = 0; i < this.libraryPrefs.length; i++) {
				if (!this.libraryPrefs[i].isAvailable) {
					all = false;
					break;
				}
			}
			this.all_libraries = all;
		}
	}

	toggleAllLibraries(): void {
		for (let i = 0; i < this.libraryPrefs.length; i++) {
			this.libraryPrefs[i].isAvailable = this.all_libraries;
		}
	}

	updateLibraries(): void {
		let prefs = {
			awpropertyObjectList: this.userService.user.properties.awpropertyObjectList,
			awsortObjectList: this.userService.user.properties.awsortObjectList,
			awfieldObjectList: this.userService.user.properties.awfieldObjectList,
			awfieldCollectionObjectList: this.userService.user.properties.awfieldCollectionObjectList,
			awlibraryObjectList: this.libraryPrefs
		};
		
		let cleanedPrefs = this.userService.cleanData(prefs);

		let payload = {
			prefs: JSON.stringify(cleanedPrefs)
		};

		this.userService.updateUser(payload).then(
			(response: any) => {
				this.browseService.cleanOnLoad = true; // FIXME: Why is this here? Do we need this?
				
				this.alertsService.success({
					message: this.LOCALIZATION.userProfileUpdateSuccess,
					delay: 5000
				});
			},
			(err: any) => {
				console.error("Failed to update user details.", err);
				this.alertsService.error({
					message: this.LOCALIZATION.userProfileUpdateError,
					delay: 5000
				});
			}
		);
	}
}
